export const ADD_ITEM = 'candidateExperience/entities/codingTests/ADD_ITEM'

export const addItem = (id, item) => ({
  type: ADD_ITEM,
  meta: { id },
  payload: item,
})

const defaultEntity = {}
const entity = (state = defaultEntity, { type, payload }) => {
  switch (type) {
    case ADD_ITEM:
      return { ...state, ...payload }

    default:
      return state
  }
}

const defaultMap = {}
const map = (state = defaultMap, { type, meta, payload }) => {
  switch (type) {
    case ADD_ITEM:
      return {
        ...state,
        [meta.id]: entity(state[meta.id], { type, payload }),
      }

    default:
      return state
  }
}

export default map

export const getCodingTestMap = state => state.entities.codingTests || defaultMap
export const getCodingTestEntity = (state, id) => state.entities.codingTests[id] || defaultEntity
